<template>
  <div class="tab-content-container">
    <div class="tab-header-container">
      <h2 class="form-label">Информация за потребителя</h2>
      <LiteButton @click.native="editButtonClicked"
                  class="edit-button"
                  v-show="!shouldEditOverallInfo"
                  :hoverColor="'blue'"
                  :icon="'far fa-edit'">
      </LiteButton>
      <LiteButton @click.native="editButtonClicked"
                  style="font-size: 27px;"
                  class="edit-button"
                  v-show="shouldEditOverallInfo"
                  :hoverColor="'red'"
                  :icon="'far fa-window-close'">
      </LiteButton>
    </div>

    <hr class="form-line">

    <!--    when preview    -->

    <!--     personal info       -->
    <div class="text-container" v-if="!shouldEditOverallInfo && !isUserLoading">
      <TextField class="text-field"
                 :label="'Потребителско име'"
                 :value="userInfoCache.username">
      </TextField>

      <TextField class="text-field"
                 :label="'Име'"
                 :value="userInfoCache.firstName">
      </TextField>

      <TextField class="text-field"
                 :label="'Фамилия'"
                 :value="userInfoCache.lastName">
      </TextField>

      <TextField class="text-field"
                 :label="'Роля'"
                 :value="userInfoCache.role">
      </TextField>

      <TextField class="text-field"
                 :label="'Акитвен'"
                 :value="userInfoCache.active ? 'Да' : 'Не'">
      </TextField>

    </div>
    <!--    when edit    -->
    <form class="form-container" v-if="shouldEditOverallInfo" style="width: 50%; margin: auto">
      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'firstName'"
                 :name="'firstName'"
                 :label="'Име'"
                 :placeholder="'Въведете име'"
                 :initialValue="userInfoCache.firstName"
                 :showError="shouldShowError('firstName')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('firstName')"
                  :text="errors['firstName']"/>

      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'lastName'"
                 :name="'lastName'"
                 :label="'Фамилия'"
                 :placeholder="'Въведете фамилия'"
                 :initialValue="userInfoCache.lastName"
                 :showError="shouldShowError('lastName')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('lastName')" :text="errors['lastName']"/>

      <SelectDropDown v-if="userRoles"
                      class="input"
                      :id="'userRolesDropdown'"
                      :name="'role'"
                      :options="userRolesOptions"
                      :placeholder="'Изберете роля'"
                      :label="'Роля'"
                      :selector="'name'"
                      :defaultSelected="{id: userInfoCache ? userInfoCache.role : ''}"
                      @selection-change="setUserRole"
      />

      <div style="width: 100%;">
        <TextField class="text-field"
                   style="width: fit-content; margin: 0 auto;"
                   :value="`Потребителският профил е '${userInfoCache.active ? 'Активен' : 'Неактивен'}'`"/>
        <Button class="save-button"
                style="margin-top: 0;"
                @click.native="activateUser"
                :color="userInfoCache.active ? 'red' : 'green'"
                :text="userInfoCache.active ? 'Деактивирай' : 'Активирай'"
                :icon="'fa fa-save'"></Button>
      </div>

      <Button class="save-button"
              @click.native="saveUser"
              :color="'green'"
              :text="'Запази'"
              :icon="'fa fa-save'"></Button>
    </form>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import InputText from "@/shared/components/form/InputText";
import ErrorInput from "@/shared/components/form/ErrorInput";
import Button from "@/shared/components/button/Button";
import LiteButton from "@/shared/components/button/LiteButton";
import TextField from "@/shared/components/TextField";
import {cloneDeep} from 'lodash';
import authorizationService from "@/services/authorization.service";
import SelectDropDown from "@/shared/components/form/SelectDropDown";

export default {
  name: "UserOverallInfo",
  components: {
    SelectDropDown,
    TextField,
    LiteButton,
    InputText,
    ErrorInput,
    Button,
  },
  created() {
    this.userInfoCache = cloneDeep(this.selectedUser);
    this.$store.dispatch('fetchUserRoles');
  },
  data() {
    return {
      userId: this.$route.params.id,
      shouldEditOverallInfo: false,
      userInfoCache: cloneDeep(this.selectedUser),
      errors: {},
    }
  },
  methods: {
    setAttribute(value) {
      this.userInfoCache[value.name] = value.currentValue;
      this.errors[value.name] = null;
    },
    setUserRole(value) {
      this.userInfoCache.role = value.currentValue;
    },
    shouldShowError(fieldName) {
      return !!(this.errors && this.errors[fieldName]);
    },
    editButtonClicked() {
      this.shouldEditOverallInfo = !this.shouldEditOverallInfo;
      this.userInfoCache = cloneDeep(this.selectedUser);
    },
    saveUser() {
      this.userInfoCache.role = this.userInfoCache.role.id;
      authorizationService.updateUser(this.userId, this.userInfoCache)
          .then(({data}) => {
            this.$store.commit('setSelectedUser', data);
            this.shouldEditOverallInfo = false;
          })
          .catch((errors) => this.errors = errors.response.data.errors);
    },
    activateUser() {
      if (this.userInfoCache.active) {
        authorizationService.deactivateUser(this.userId)
        .then(() => {
          this.$store.dispatch('fetchUserById', this.userId);
          this.shouldEditOverallInfo = false;
        })
        .catch(() => {
          this.$store.dispatch('fetchUserById', this.userId);
          this.shouldEditOverallInfo = false;
        })
      } else {
        authorizationService.activateUser(this.userId)
            .then(() => {
              this.$store.dispatch('fetchUserById', this.userId);
              this.shouldEditOverallInfo = false;
            })
            .catch(() => {
              this.$store.dispatch('fetchUserById', this.userId);
              this.shouldEditOverallInfo = false;
            })
      }
    }
  },
  computed: {
    ...mapGetters(['selectedUser', 'isUserLoading', 'userRoles']),

    userRolesOptions() {
      if (this.userRoles) {
        let temp = cloneDeep(this.userRoles);
        temp = temp.map(role => ({id: role, name: role}));
        return temp;
      }
      return [];
    }
  },
  watch: {
    selectedUser: {
      handler() {
        this.userInfoCache = cloneDeep(this.selectedUser)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.form-container {
  width: 100%;
  height: fit-content;
}

.form-column-container {
  width: 50%;
  padding: 20px 140px;
  margin: 0 auto;
  display: inline-grid;
  height: fit-content;
  box-sizing: border-box;
}

.input {
  height: 95px;
  margin: 20px auto 0 auto;
}

.car-datepicker-label {
  float: left;
  height: 30px;
  width: 100%;
  text-align: left;
  margin-left: 5px;
  font-size: 20px;
  color: var(--dark-grey);
}

.input-date {
  margin: 20px 0 0 0;
}
</style>
